import { render, staticRenderFns } from "./homeTabs.vue?vue&type=template&id=0fbc5703&scoped=true&"
import script from "./homeTabs.vue?vue&type=script&lang=js&"
export * from "./homeTabs.vue?vue&type=script&lang=js&"
import style0 from "./homeTabs.vue?vue&type=style&index=0&id=0fbc5703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc5703",
  null
  
)

export default component.exports